import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "../../stripe-dashboard.module.css";

function MRRGrowthChart({ data }) {
  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Crescimento do MRR</p>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tickFormatter={v => `R$${v / 1000}k`}
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{ background: "#0f172a", border: "none", borderRadius: 8, fontSize: 12 }}
            labelStyle={{ color: "rgba(255,255,255,0.6)" }}
            itemStyle={{ color: "#fff" }}
            formatter={v =>
              new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v)
            }
          />
          <Legend wrapperStyle={{ fontSize: 12, color: "#64748b" }} />
          <Line
            type="monotone"
            dataKey="value"
            name="MRR"
            stroke="#035184"
            strokeWidth={2}
            dot={{ fill: "#035184", r: 3 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MRRGrowthChart;
